// extracted by mini-css-extract-plugin
module.exports = {"cta":"styles_cta__K8Le_","cta__content":"styles_cta__content__VJJ9N","rotate":"styles_rotate__vqjrK","rotate-reverse":"styles_rotate-reverse__kwJqn"};